import React, { useLayoutEffect, useRef, useState } from 'react';

import styles from './FunnelChart.module.scss';

const FunnelChart = ({response}: any) => {
  const impressionsRef = useRef<HTMLDivElement>(null);
  const clicksRef = useRef<HTMLDivElement>(null);
  const cnvRef = useRef<HTMLDivElement>(null);

  const [percentPositions, setPercentPositions] = useState({
    betweenImpressionsAndClicks: 0,
    betweenClicksAndCnv: 0,
  });

  useLayoutEffect(() => {
    if (impressionsRef.current && clicksRef.current && cnvRef.current) {
      const impRect = impressionsRef.current.getBoundingClientRect();
      const clicksRect = clicksRef.current.getBoundingClientRect();
      const cnvRect = cnvRef.current.getBoundingClientRect();

      const topBetweenImpressionsAndClicks =
        impRect.bottom + (clicksRect.top - impRect.bottom) / 2;

      const topBetweenClicksAndCnv =
        clicksRect.bottom + (cnvRect.top - clicksRect.bottom) / 2;

      // Adjust for the parent container's relative position
      const containerTop = impressionsRef.current.parentElement?.getBoundingClientRect().top || 0;

      setPercentPositions({
        betweenImpressionsAndClicks: topBetweenImpressionsAndClicks - containerTop,
        betweenClicksAndCnv: topBetweenClicksAndCnv - containerTop,
      });
    }
  }, []);

  return (
    <div className={styles.funnelContainer}>
      <div className={`${styles.funnelStep} ${styles.impressions}`} ref={impressionsRef}>
        <div className={styles.label}>IMPRESSIONS</div>
        <div className={styles.value}>{response.impressions.Value || 0}</div>
      </div>

      <div
        className={styles.percentage}
        style={{ top: `${percentPositions.betweenImpressionsAndClicks - 8 }px` }}
      >
        {response.impressions.Percentage || "0%"}
      </div>

      <div className={`${styles.funnelStep} ${styles.clicks}`} ref={clicksRef}>
        <div className={styles.label}>CLICKS</div>
        <div className={styles.value}>{response.clicks.Value || 0}</div>
      </div>

      <div
        className={styles.percentage}
        style={{ top: `${percentPositions.betweenClicksAndCnv - 8}px` }}
      >
        {response.clicks.Percentage || "0%"}
      </div>

      <div className={`${styles.funnelStep} ${styles.cnv}`} ref={cnvRef}>
        <div className={styles.label}>Goals</div>
        <div className={styles.value}>{response.cnv.Value ||  0}</div>
      </div>
    </div>
  );
};

export default FunnelChart;